export const manifest = {
  screens: {
    scr_79zg9d: { name: "Home", route: "/" },
  },
}
